import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar, Pie, Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [department, setDepartment] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const workflowData = {
    labels: ['Workflow A', 'Workflow B', 'Workflow C'],
    datasets: [
      {
        label: 'Completion %',
        data: [85, 60, 95],
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
      },
    ],
  };

  const taskData = {
    labels: ['To Do', 'In Progress', 'Review', 'Done'],
    datasets: [
      {
        label: 'Tasks',
        data: [10, 15, 5, 20],
        backgroundColor: [
          '#f39c12',
          '#3498db',
          '#9b59b6',
          '#2ecc71'
        ],
      },
    ],
  };

  const agentActivityData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    datasets: [
      {
        label: 'Agent Activity',
        data: [3, 6, 4, 8, 5],
        fill: false,
        borderColor: '#e74c3c',
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true },
    },
  };

  return (
    <div className="container my-4">
      <h2 className="mb-4">Dashboard Overview</h2>

      <div className="row mb-4">
        <div className="col-md-3">
          <input
            type="text"
            className="form-control"
            placeholder="Department"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary w-100" >
            Apply Filters
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Total Tasks</h5>
              <p className="card-text">50</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Active Workflows</h5>
              <p className="card-text">5</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">AI Agent Suggestions</h5>
              <p className="card-text">Optimize Project X, Alert on SLA breach</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title mb-3">Workflow Progress</h5>
            <Bar data={workflowData} options={{ ...options, title: { text: 'Workflow Progress' } }} />
          </div>
        </div>
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title mb-3">Task Distribution</h5>
            <Pie data={taskData} options={{ ...options, title: { text: 'Task Status Split' } }} />
          </div>
        </div>
        <div className="col-12 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title mb-3">AI Agent Activity</h5>
            <Line data={agentActivityData} options={{ ...options, title: { text: 'Agent Usage Over Time' } }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;